import { Injectable, NgZone } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class ResponsiveService {
	static readonly MOBILE_BREAKPOINT = 768;

	private isMobile$ = new BehaviorSubject<boolean>(this.checkIsMobile());

	readonly isMobileChanges: Observable<boolean> = this.isMobile$.asObservable().pipe(distinctUntilChanged());

	constructor(private zone: NgZone) {
		this.zone.runOutsideAngular(() => {
			window.addEventListener("resize", this.onResize);
		});
	}

	get isMobile(): boolean {
		return this.isMobile$.value;
	}

	private onResize = (): void => {
		const next = this.checkIsMobile();
		if (next !== this.isMobile$.value) {
			this.zone.run(() => this.isMobile$.next(next));
		}
	};

	private checkIsMobile(): boolean {
		return typeof window !== "undefined" && window.innerWidth <= ResponsiveService.MOBILE_BREAKPOINT;
	}
}
